import type { SliderProps } from '@change/ds-forms';

import { useI18n } from '@change-corgi/core-react/i18n';

import { usePromoteFormData } from '../../../formContext/formData';
import { usePromoteFormState } from '../../../formContext/formState';

type Result = {
	amount: number;
	minAmount: number;
	maxAmount: number;
	minSliderAmount: number | undefined;
	maxSliderAmount: number | undefined;
	sliderStep: number | undefined;
	sliderLayout: SliderProps['layout'] | undefined;
};

export function useEnforceMembershipAmount(): () => Result {
	const { amountFromBaseUnits } = useI18n();
	const [{ amount: originalAmount }] = usePromoteFormState();
	const { currency, subscriptionConfiguration } = usePromoteFormData();

	// oxlint-disable-next-line max-statements -- exceeds the 18-statement limit; flagged as documented debt rather than refactored, per team decision
	return function enforceMembershipAmount(): Result {
		let subscriptionMaxAmount = Number.MAX_SAFE_INTEGER;
		let subscriptionMinAmount = 0;
		let subscriptionMinSliderAmount: number | undefined;
		let subscriptionMaxSliderAmount: number | undefined;
		let subscriptionSliderStep: number | undefined;
		let subscriptionSliderLayout: SliderProps['layout'] | undefined;
		let amount = originalAmount;
		if (subscriptionConfiguration) {
			subscriptionMinAmount = amountFromBaseUnits(subscriptionConfiguration.minAmount, currency.code);
			subscriptionMaxAmount = amountFromBaseUnits(subscriptionConfiguration.maxAmount, currency.code);
			if (subscriptionConfiguration.minSliderAmount !== undefined) {
				subscriptionMinSliderAmount = amountFromBaseUnits(subscriptionConfiguration.minSliderAmount, currency.code);
			}
			if (subscriptionConfiguration.maxSliderAmount !== undefined) {
				subscriptionMaxSliderAmount = amountFromBaseUnits(subscriptionConfiguration.maxSliderAmount, currency.code);
			}
			subscriptionSliderStep = subscriptionConfiguration.sliderStep;
			subscriptionSliderLayout = subscriptionConfiguration.sliderLayout;
			if (subscriptionMinAmount > amount) {
				amount = subscriptionMinAmount;
			} else if (amount > subscriptionMaxAmount) {
				amount = subscriptionMaxAmount;
			}
		}
		return {
			amount,
			minAmount: subscriptionMinAmount,
			maxAmount: subscriptionMaxAmount,
			minSliderAmount: subscriptionMinSliderAmount,
			maxSliderAmount: subscriptionMaxSliderAmount,
			sliderStep: subscriptionSliderStep,
			sliderLayout: subscriptionSliderLayout,
		};
	};
}
